export default "__VITE_ASSET__kBYBudNe__"